import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

// Fetch user data based on userId
export const getAdminData = async (userId) => {
  try {
    let user = null;
    const response = await axiosInstance.get(API.user.getById(userId));
    user = response.data || null;
    return {
      id: user.id,
      firstName: user.firstName || "",
      lastName: user.lastName || "",
      userName: user.userName || user.email || "",
      email: user.email || "",
    };
  } catch (error) {
    console.error("Error fetching user data:", error.response?.data || error.message);
    return null;
  }
};

// Fetch job postings
export const getJobPostings = async () => {
  try {
    const response = await axiosInstance.get(API.hiringJobPosting.getAll);
    return response.data;
  } catch (error) {
    console.error("Error fetching job postings from API:", error.response?.data || error.message);
    throw error;
  }
};

// Add a new job posting
export const addJobPosting = async (jobData) => {
  try {
    const response = await axiosInstance.post(API.hiringJobPosting.add, jobData);
    return response.data;
  } catch (error) {
    console.error("Error adding job posting:", error.response?.data || error.message);
    throw error;
  }
};

// Update an existing job posting
export const updateJobPosting = async (jobData) => {
  try {
    const response = await axiosInstance.put(API.hiringJobPosting.update, jobData);
    return response.data;
  } catch (error) {
    console.error("Error updating job posting:", error.response?.data || error.message);
    throw error;
  }
};
